import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getClaimContract } from "../../utils/contractHelpers";
import { CLAIMING_ADDRESS } from "../../utils/Enviroment";

export const Claim = () => {
  const web3 = useWeb3();
  const stakingAddress = CLAIMING_ADDRESS;
  const contract = getClaimContract(stakingAddress, web3);
  const { account } = useWeb3React();
  const ClaimHook = useCallback(
    async (index) => {
      let gasPrice = await web3.eth.getGasPrice();
      // gasPrice = parseInt(gasPrice) + 1000000000;
      try {
        const gas = await contract?.methods
          ?.claimRequest(index)
          ?.estimateGas({ from: account });
        const Claim = await contract?.methods
          ?.claimRequest(index)
          ?.send({ from: account, gas: gas, gasPrice: gasPrice });
        return Claim;
      } catch (e) {
        throw e;
      }
    },
    [contract, web3, account]
  );
  return { ClaimHook: ClaimHook };
};

export default Claim;
